import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'masterProduct';

const functions = {
    async get() {
        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncMasterVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async getLatestData(saveData) {
        if (saveData.masterProductKey) {
            const updateData = await this.getDetail(saveData.masterProductKey);

            if (updateData) {
                return updateData;
            }
        }

        return saveData;
    }
}

export default functions;